import type { BannerVisibleParams } from '~/entities/player/trailer/index.h'
import type { ShowWithPrice, VodWithPrice } from '~/shared/interfaces'
import type { BannerBundle } from './index.h'

import { TrailerContentType } from '~/entities/player/trailer/index.h'

function getBannerContentType(
  contentType: BannerBundle['contentType']
): TrailerContentType | null {
  if (contentType === 'TV_SHOW') return TrailerContentType.TVSHOW
  if (contentType === 'VOD') return TrailerContentType.VOD
  return null
}

export function buildBannerVisibleParams(
  item: BannerBundle,
  {
    autoScrollIn = 0,
    autoScrollEnabled,
    locked,
    free,
  }: {
    autoScrollIn?: number
    autoScrollEnabled?: boolean
    locked: boolean
    free: boolean
  }
): BannerVisibleParams | null {
  const cardContent = item.content
  if (!cardContent?.id) return null

  const contentType = getBannerContentType(item.contentType)
  if (!contentType) return null

  return {
    contentId: cardContent.id,
    contentType,
    trailerPresent: Boolean(
      (cardContent as VodWithPrice | ShowWithPrice)?.trailerPresent
    ),
    resourceType: item.resourceType ?? '',
    autoScrollIn,
    locked,
    free,
    autoScrollEnabled,
    contentName: cardContent.name,
    blockedByAcl: cardContent.blockedByAcl,
  }
}
